import React from "react";
import { useNavigate } from "react-router-dom";
import {FarewiseIcon} from "../../assets/svgComponents/farewiseIcon";
import {useTranslation} from "../../i18n/LanguageProvider";

const HomeButton: React.FC = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <button
      onClick={handleClick}
      className="hover:opacity-80 transition"
      aria-label={t("home.aria")}
    >
      <FarewiseIcon />
    </button>
  );
};

export default HomeButton;
